import axios from 'axios';
import {showErrorNotification, showSuccessNotification} from "../notifications";

export const googleAuthExchangeForNeurotuneAuth = async (credential: string): Promise<void> => {
  try {
    const response = await axios.post(`${window.BIOS.neurotune_base_url}/auth`, {
      credential
    }, {
      headers: { "Content-Type": "application/json" },
      withCredentials: true,
    });
    console.log("Login response:", response.data);

    showSuccessNotification({ title: "Login Successful", message: "", autoClose:1000});
  } catch (error: any) {
    const message = error.response?.data?.detail || error.message || "Login failed";
    showErrorNotification({ title: "Login Failed", message });
    throw new Error(message);
  }
};
